module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Pantone-c938f56d173b8cac2f16a7a2d89f8a54.svg";